import React from "react";

const toolTip = (props) => {
  return props.canShowToolTip ? (
    <div
      className={props.isError == undefined? "toolTip":
        props.isError ? "toolTipError": "fullError"}
      style={props.style}
    >
      <span >{props.text}</span>
    </div>
  ) : null;
};

export default toolTip;
